var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container textual mb-5 alturaMin"},[(_vm.loading)?_c('div',[_c('Loading')],1):_c('div',[_c('h1',{staticClass:"title mb-5"},[_vm._v("Regras e Dúvidas")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }